export function getAudioType() {
  const ARTICLE = 'article';
  return {
    ARTICLE,
  };
}
export function a() {}
